var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("Nächste Termine:")]),_c('b-list-group',{attrs:{"to":"/Kalender"}},_vm._l((_vm.events),function(event){return _c('CalendarShortListEntry',{key:event.id})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }